<template>
  <div>
    <!-- === BANNER === -->
    <div
      v-if="showBanner"
      class="cookie-banner"
      role="dialog"
      aria-live="polite"
    >
      <div class="cookie-banner-inner">
        <div class="cookie-banner-text">
          <strong>{{ StoreLangTranslation.data['we_use_cookies'][StoreLang] }}</strong>
          {{ StoreLangTranslation.data['use_cookies_to_ensure_our_website_works'][StoreLang] }}
        </div>

        <div class="cookie-banner-actions">
          <button @click="rejectAll" class="cookie-btn cookie-btn-danger">
            {{ StoreLangTranslation.data['reject_all'][StoreLang] }}
          </button>
          <button @click="openModal" class="cookie-btn cookie-btn-outline">
            {{ StoreLangTranslation.data['save_preferences'][StoreLang] }}
          </button>
          <button @click="acceptAll" class="cookie-btn cookie-btn-primary">
            {{ StoreLangTranslation.data['accept_all'][StoreLang] }}
          </button>
        </div>
      </div>
    </div>

    <!-- === MODAL BACKDROP === -->
    <div
      v-if="showModal"
      class="cookie-modal-backdrop"
      @click="backdropClose"
      aria-hidden="false"
    >
      <div class="cookie-modal" @click.stop>
        <div class="cookie-modal-header">
          <div>
            <div class="cookie-modal-title">{{ StoreLangTranslation.data['cookie_preferences'][StoreLang] }}</div>
            <div class="cookie-modal-subtitle">
              {{ StoreLangTranslation.data['specify_which_cookie'][StoreLang] }}
            </div>
          </div>
          <button class="cookie-modal-close" @click="closeModal">×</button>
        </div>

        <div class="cookie-modal-body">
          <!-- ZORUNLU -->
          <section class="cookie-category">
            <div class="cookie-category-header">
              <div>
                <div class="cookie-category-title">{{ StoreLangTranslation.data['mandatory_cookies'][StoreLang] }}</div>
                <div class="cookie-category-desc">
                  {{ StoreLangTranslation.data['essential_for_the_site_to_function'][StoreLang] }}
                </div>
              </div>
              <div class="cookie-toggle-wrapper">
                <label class="cookie-switch">
                  <input type="checkbox" checked disabled />
                  <span class="cookie-switch-slider"></span>
                </label>
                <span class="cookie-category-chip">{{ StoreLangTranslation.data['necessary'][StoreLang] }}</span>
              </div>
            </div>
          </section>

          <!-- TERCIH -->
          <section class="cookie-category">
            <div class="cookie-category-header">
              <div>
                <div class="cookie-category-title">
                  {{ StoreLangTranslation.data['preference_cookies'][StoreLang] }}
                </div>
                <div class="cookie-category-desc">
                  {{ StoreLangTranslation.data['allows_the_system_to_remember_language'][StoreLang] }}
                </div>
              </div>
              <label class="cookie-switch">
                <input type="checkbox" v-model="consent.preferences" />
                <span class="cookie-switch-slider"></span>
              </label>
            </div>
          </section>

          <!-- ANALITIK -->
          <section class="cookie-category">
            <div class="cookie-category-header">
              <div>
                <div class="cookie-category-title">
                  {{ StoreLangTranslation.data['performance_and_analytics_cookies'][StoreLang] }}
                </div>
                <div class="cookie-category-desc">
                  {{ StoreLangTranslation.data['anonymous_analytics_are_conducted'][StoreLang] }}
                </div>
              </div>
              <label class="cookie-switch">
                <input type="checkbox" v-model="consent.analytics" />
                <span class="cookie-switch-slider"></span>
              </label>
            </div>
          </section>

          <!-- PAZARLAMA -->
          <section class="cookie-category">
            <div class="cookie-category-header">
              <div>
                <div class="cookie-category-title">
                  {{ StoreLangTranslation.data['marketing_and_targeting_cookies'][StoreLang] }}
                </div>
                <div class="cookie-category-desc">
                  {{ StoreLangTranslation.data['content_and_ads_based_on_your_interests'][StoreLang] }}
                </div>
              </div>
              <label class="cookie-switch">
                <input type="checkbox" v-model="consent.marketing" />
                <span class="cookie-switch-slider"></span>
              </label>
            </div>
          </section>
        </div>

        <div class="cookie-modal-footer">
          <button @click="rejectAll()" class="cookie-btn cookie-btn-danger">
            {{ StoreLangTranslation.data['reject_all'][StoreLang] }}
          </button>
          <button @click="savePreferences()" class="cookie-btn cookie-btn-primary">
            {{ StoreLangTranslation.data['save_preferences'][StoreLang] }}
          </button>
        </div>
      </div>
    </div>
    <div id="cookieWarning" style="
        display:none;
        background:#fee2e2;
        color:#b91c1c;
        padding:14px;
        border-radius:8px;
        margin:10px 0;
        border:1px solid #fecaca;
    ">
      {{ StoreLangTranslation.data['cookies_are_disabled_in_your_browser'][StoreLang] }}
      <button @click="acceptCookies()">{{ StoreLangTranslation.data['allow_cookies'][StoreLang] }}</button>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "CookieConsent",
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  data() {
    return {
      STORAGE_KEY: "cookieConsent",
      showBanner: false,
      showModal: false,
      consent: {
        necessary: true,
        preferences: false,
        analytics: false,
        marketing: false,
      },
    };
  },

  created() {
    const stored = localStorage.getItem(this.STORAGE_KEY);

    if (stored) {
      this.consent = JSON.parse(stored);
      this.$emit("updated", this.consent);
    } else {
      // İlk defa gelen kullanıcı
      this.showBanner = true;
    }
  },
  mounted() {
    if (!this.areCookiesEnabled()) {
      document.getElementById("cookieWarning").style.display = "block";
    }
  },
  methods: {
    'acceptCookies': function () {
      // Kullanıcı onayını kaydediyoruz
      document.cookie = "consent=accepted; path=/; max-age=31536000";
      alert("Çerez kullanımına izin verdiniz.");
    },
    'areCookiesEnabled': function() {
      try {
        document.cookie = "cookietest=1; SameSite=Lax";
        const enabled = document.cookie.indexOf("cookietest=") !== -1;
        document.cookie = "cookietest=1; expires=Thu, 01 Jan 1970 00:00:00 GMT";
        return enabled;
      } catch {
        return false;
      }
    },
    'acceptAll': function() {
      this.consent.preferences = true;
      this.consent.analytics = true;
      this.consent.marketing = true;
      this.save();
    },

    'rejectAll': function() {
      this.consent.preferences = false;
      this.consent.analytics = false;
      this.consent.marketing = false;
      this.save();
    },

    'savePreferences': function() {
      this.save();
    },

    'save': function() {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.consent));
      this.$emit("updated", this.consent);

      this.showBanner = false;
      this.showModal = false;
    },

    'openModal': function() {
      this.showModal = true;
      this.showBanner = false;
    },

    'closeModal': function() {
      this.showModal = false;
    },

    'backdropClose': function(e) {
      if (e.target === e.currentTarget) {
        this.closeModal();
      }
    },
  },
};
</script>

<style scoped>
/* --- CSS Tümü: Banner, modal, butonlar, switchler --- */

.cookie-banner {
  position: fixed;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  max-width: 960px;
  width: calc(100% - 32px);
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
  border: 1px solid #e0e4eb;
  padding: 16px;
  z-index: 9999;
}

.cookie-banner-inner {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cookie-banner-text strong {
  display: block;
  margin-bottom: 4px;
}

.cookie-banner-actions {
  display: flex;
  gap: 8px;
}

.cookie-btn {
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 13px;
  border: 1px solid transparent;
  cursor: pointer;
  white-space: nowrap;
}

.cookie-btn-primary {
  background: #2563eb;
  color: #fff;
}
.cookie-btn-outline {
  background: #fff;
  border-color: #d1d5db;
}
.cookie-btn-danger {
  background: #d92d20;
  color: #fff;
}

.cookie-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 10000;
  top: 200px;
}

.cookie-modal {
  max-width: 760px;
  width: 100%;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.cookie-modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
}

.cookie-modal-close {
  background: transparent;
  border: none;
  font-size: 22px;
  cursor: pointer;
}

.cookie-modal-body {
  padding: 16px 20px;
}

.cookie-category {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
}

.cookie-category-title {
  font-size: 14px;
  font-weight: 600;
}

.cookie-category-desc {
  font-size: 13px;
  color: #6b7280;
}

.cookie-switch {
  position: relative;
  width: 40px;
  height: 22px;
}
.cookie-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.cookie-switch-slider {
  position: absolute;
  inset: 0;
  background: #d1d5db;
  border-radius: 999px;
  cursor: pointer;
  transition: 0.2s;
}
.cookie-switch-slider::before {
  content: "";
  height: 16px;
  width: 16px;
  background: white;
  position: absolute;
  left: 3px;
  bottom: 3px;
  border-radius: 50%;
  transition: 0.2s;
}

.cookie-switch input:checked + .cookie-switch-slider {
  background: #2563eb;
}
.cookie-switch input:checked + .cookie-switch-slider::before {
  transform: translateX(18px);
}

.cookie-modal-footer {
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>